import axios from 'axios';

export function joinGroup(groupId, contactId) {
  return axios.post('/api/?entity=groups&action=joinGroup', {groupId, contactId});
}
